import { render, staticRenderFns } from "./ClassifyCom.vue?vue&type=template&id=826e54e8&scoped=true"
import script from "./ClassifyCom.vue?vue&type=script&lang=js"
export * from "./ClassifyCom.vue?vue&type=script&lang=js"
import style0 from "./ClassifyCom.vue?vue&type=style&index=0&id=826e54e8&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826e54e8",
  null
  
)

export default component.exports